/** PHI-clean properties only — never message bodies, names, or phone numbers. */
export enum MessagingAnalyticsEvents {
  // Reliability signals (observability RFC). SMS vs MMS via hasAttachment.
  MessageSent = 'message_sent',
  MessageSendFailed = 'message_send_failed',
  // MMS viewing.
  MmsMessagePreviewed = 'mms_message_previewed',
  MmsMessageDownloaded = 'mms_message_downloaded',
  MmsPreviewDownloadMissingParams = 'mms_preview_download_failed_missing_params',
  MmsPreviewDownloadFailed = 'mms_preview_download_failed',
  // Threads.
  ThreadSelected = 'thread_selected',
  ThreadRenameRequest = 'thread_rename_request',
  NewThreadModalOpened = 'new_thread_modal_opened',
  NewThreadModalGroupSelected = 'new_thread_modal_group_selected',
  NewThreadModalSendPressed = 'new_thread_modal_send_pressed',
  MarkAllAsRead = 'mark_all_as_read',
  UpgradeButtonClicked = 'upgrade_button_clicked',
  QuickActionCall = 'quick_action_c2c',
  // Snippets.
  SnippetSelected = 'snippet_selected',
  CreateSnippetSuccess = 'create_snippet_success',
  CreateSnippetFailure = 'create_snippet_failure',
  DeleteSnippetSuccess = 'delete_snippet_success',
}
